import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { MoneyForBuckService } from 'src/app/service/money-for-buck-service/money-for-buck.service';
import { sweetAlert } from 'src/app/utils/swal';
import { DriversService } from '../../../drivers/drivers-service/drivers-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AssistService } from 'src/app/service/assist-service/assist.service';

@Component({
  selector: 'app-add-assist',
  templateUrl: './add-assist.component.html',
  styleUrls: ['./add-assist.component.css']
})
export class AddAssistComponent implements OnInit {

  assistForm : UntypedFormGroup
  submitted: boolean;
  selectedDriver: any;
  user: any;
  timeZone: any;
  driverList: any = [];
  assistList:any;
  buckId: string;
  constructor(
    private assistService : AssistService,
    private fb: UntypedFormBuilder,
    private mfbService: MoneyForBuckService,
    private driverService : DriversService,
    private sharedDataService : SharedDataService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }


  ngOnInit() {
    if (this.activatedRoute.snapshot.url.length === 4 && this.activatedRoute.snapshot.url[3].path === 'edit') {
      this.buckId = this.activatedRoute.snapshot.url[2].path;
      
    }
    this.assistForm = this.fb.group({
      loadedMilesRate: ['',Validators.required],
      deadMilesRate: ['',Validators.required],
      preStartDate: ['',Validators.required],
      startTime: ['',Validators.required],
      preEndDate: ['',Validators.required],
      endTime: ['',Validators.required],
      status: ['',Validators.required],
      driver: ['',Validators.required]
    })
    this.getUser();
    this.getAssisData();
    if(this.buckId){
      this.getBuckById();
    }
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = user.timeZone;
          this.getDriverList();

        }
      });
  }

  getBuckById() {
    this.assistService
      .getBuckAttendeebyId(this.buckId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.assistForm.patchValue({
            ...data,
            preStartDate: moment(data.startTime).startOf('day'),
            startTime : data.startTime,
            preEndDate: moment(data.endTime).endOf('day'),
            endTime: data.endTime
          })
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.driverList = data;
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  onSubmit() {
    this.submitted = true;
    if (this.assistForm.invalid) {
      return;
    }
    if (this.selectedDriver) {
      this.assistForm.patchValue({
        driver: this.selectedDriver
      })
    }
    let payload = this.assistForm.value;
    this.assistService.addBuckAttendee(payload, this.buckId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            const currentUrl = this.activatedRoute.snapshot.url[1].path;  
            this.router.navigate([`/mfb/${currentUrl}`]);
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }
  onDateChange(evt, control: AbstractControl) {
    if (evt) {
      control.setValue(moment(evt).toISOString());
    }
  }

  get form(){
    return this.assistForm.controls;
  }

  onSelectDriver(event){
    this.selectedDriver = event
  }

  getAssisData(){
    // let queryParams = {
    //   scheduleTime: this.trip.scheduleTime
    // }
    this.assistService.getAssistList()
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data => {
      if (data) {
        this.assistList = data;
      }
    });
  }

  ngOnDestroy(): void {
  }


}
